(() => {
  const headerSection = document.querySelector('.section-header');

  if (!headerSection) return;

  let frameRequested = false;

  const updateScrollState = () => {
    headerSection.classList.toggle('sliv-home-header--scrolled', window.scrollY > 1);
    frameRequested = false;
  };

  const requestScrollUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateScrollState);
  };

  const updateMenuState = () => {
    headerSection.classList.toggle(
      'sliv-home-header--menu-open',
      Boolean(headerSection.querySelector('details[open]'))
    );
  };

  const menuObserver = new MutationObserver(updateMenuState);
  menuObserver.observe(headerSection, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });

  window.addEventListener('scroll', requestScrollUpdate, { passive: true });
  window.addEventListener('pageshow', updateScrollState);

  updateScrollState();
  updateMenuState();
})();


